import {
    RaikoSectionContainer,
    RaikoBaseCardContainer,
    RaikoMaterialOutlinedInput,
    RaikoGridTwoColumn,
    showErrorMessage,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoFlexFirstChildGrowOne,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoHtmlTextEditor,
    RaikoConfirmDialog,
    showSuccessMessage,
    RaikoCreatorInfo,
    convertUniversalDateTimeToPersianDateTime,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components"
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {NotificationsService} from "../../serverService/notificationsService/NotificationsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {stringIsEmpty} from "../../util/VariableChecker";
import RaikoTextEditor from "../../raikoComponents/raikoTextEditor/RaikoTextEditor";
import AdvanceRichEditor from "../../raikoComponents/raikoEditor/raikoRichEditor/AdvanceRichEditor";

export default function NotificationDetail() {
    const {state} = useLocation()
    const [notificationTitle, setNotificationTitle] = useState(state && state.title ? state.title : RouteHelper.NotificationsDetail.name)
    const [tabValue, setTabValue] = useState(NotificationDetailTabTypes.NotificationDetails.id)

    function handleChangeTab(event, newValue) {
        setTabValue(newValue)
    }

    const navigate = useNavigate()

    const [title, setTitle] = useState("")
    const [writerName, setWriterName] = useState("")
    const [text, setText] = useState("")
    const [enabled, setEnabled] = useState(false)
    const [buttonLoading, setButtonLoading] = useState(false)
    const [postedAt, setPostedAt] = useState("")
    const [postedBy, setPostedBy] = useState("")
    const [openConFirmDialog, setOpenConfirmDialog] = useState(false);
    const openDeleteDialog = () => setOpenConfirmDialog(true)
    const closeDeleteDialog = () => setOpenConfirmDialog(false)

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new NotificationsService()

    const {id: notificationId} = useParams()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getNotificationDetail()
        }
    }, []);

    function getNotificationDetail() {
        loading.show()
        service.getNotificationDetail(notificationId).then(
            response => {
                setTitle(response.title)
                setWriterName(response.authorInformation)
                setText(response.description)
                setEnabled(response.enabled)
                setPostedAt(convertUniversalDateTimeToPersianDateTime(response.postedAt))
                setPostedBy(response.postedBy)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function checkingAllInputs() {
        let state = false;
        let message
        if (stringIsEmpty(title))
            message = "لطفا عنوان اطلاعیه را وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نام نویسنده را وارد نمایید."
        else if (stringIsEmpty(text))
            message = "لطفا متن اطلاعیه را وارد نمایید."
        else
            state = true
        if (message)
            showWarningMessage(message)
        return state
    }

    function updateNotification() {
        setButtonLoading(true)
        if (checkingAllInputs()) {
            service.updateNotification(title, writerName, text, enabled, notificationId).then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setButtonLoading(false)
            })
        }
    }

    function deleteNotification() {
        loading.show()
        service.deleteNotification(title, writerName, text, false, notificationId).then(
            response => {
                showSuccessMessage("حذف اطلاعیه با موفقیت انجام شد.")
                closeDeleteDialog()
                navigate(
                    RouteHelper.NotificationsList.globalUrl,
                    {replace: true}
                )
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.NotificationsDetail.name}</title>
            </Helmet>
            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openConFirmDialog}
                doAction={deleteNotification}
                pageTitle={"حذف اطلاعیه"}
                warningTitle={"آیا از حذف اطلاعیه اطمینان دارید؟"}
            />
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={
                                [raikoBreadCrumbItemGenerator(
                                    RouteHelper.NotificationsList.name,
                                    RouteHelper.NotificationsList.url
                                ), raikoBreadCrumbItemGenerator(
                                    notificationTitle,
                                    ""
                                )
                                ]
                            }
                        />
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>

                    </RaikoFlexFirstChildGrowOne>
                    <TabContext value={tabValue}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={NotificationDetailTabTypes.NotificationDetails.title}
                                     value={NotificationDetailTabTypes.NotificationDetails.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={NotificationDetailTabTypes.NotificationDetails.id}>
                            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        title={"اطلاعیه"}
                                        hasActionButton={true}
                                        actionButtonTitle={"بروزرسانی"}
                                        actionButtonOnclick={updateNotification}
                                        actionButtonLoadingState={buttonLoading}
                                        hasSecondaryButton={true}
                                        secondaryButtonTitle={"حذف"}
                                        secondaryButtonOnClick={openDeleteDialog}
                                    >
                                        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;max-width: 100vw;`}>
                                            <RaikoGridTwoColumn>
                                                <RaikoMaterialOutlinedInput
                                                    labelText={"عنوان"}
                                                    value={title}
                                                    setValue={setTitle}
                                                />
                                                <RaikoMaterialOutlinedInput
                                                    labelText={"نام نویسنده"}
                                                    value={writerName}
                                                    setValue={setWriterName}
                                                />
                                            </RaikoGridTwoColumn>
                                            <RaikoGridOneColumn>
                                                <AdvanceRichEditor
                                                    text={text}
                                                    setText={setText}
                                                />
                                            </RaikoGridOneColumn>
                                        </RaikoGridOneColumn>
                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>
                                <RaikoCreatorInfo createdBy={postedBy} createdAt={postedAt}/>
                            </RaikoGridOneColumn>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const NotificationDetailTabTypes = {
    NotificationDetails: {
        id: "notification-details",
        title: "جزئیات اطلاعیه"
    },
}